import Component from './Component';
import Flickity from 'flickity';
import {swiffyslider} from 'swiffy-slider';

// This is made so that it can be used globally.
window.satc.runFlickityOnRelatedContentProduct = runFlickityOnRelatedContentProduct;
window.satc.runSwiffysliderOnRelatedContentProduct = runSwiffysliderOnRelatedContentProduct;

export default class RelatedContent extends Component {
  load() {
    // Flickity carousel is legacy and we will gradually remove it and use SwiffySlider instead.
    global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
    global.swiffyslider.init();          // start swiffyslider
    // console.log('swiffyslider : ', global.swiffyslider );

    this.initFlickity();
    super.load();
  }

  initFlickity() {

    const relatedContent = document.querySelectorAll('.js-related-content__banner');
    if(relatedContent) {
      Array.prototype.slice.call(relatedContent).map((el) => {


        const relatedContentFlickity = new Flickity(el, {
          cellAlign: 'center',
          contain: false,
          pageDots: true,
          prevNextButtons: true,
          wrapAround: true,
          imagesLoaded: true,
        });

        $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
          [
            { minSize: 0, group: 1 },
            { minSize: 560, group: 2 },
            { minSize: 992, group: 3 },
          ].reverse().find((size) => {
            if($(window).width() >= size.minSize) {
              if(relatedContentFlickity.options.groupCells !== size.group) {
                relatedContentFlickity.options.groupCells = size.group;
                relatedContentFlickity.options.wrapAround = (relatedContentFlickity.cells.length > size.group);

                relatedContentFlickity.resize();
              }

              return size;
            }
          });
        }));
      });
    }

    runFlickityOnRelatedContentProduct();

    const sixColProduct = document.querySelectorAll('.related-content--six-col .related-content__list');
    if(sixColProduct) {
      Array.prototype.slice.call(sixColProduct).map((el) => {
        const autoPlay = el.dataset.autoplay === 'true';

        const relatedContentFlickity = new Flickity(el, {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          prevNextButtons: true,
          wrapAround: true,
          autoPlay: autoPlay,
        });

        $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
          [
            { minSize: 0, group: 1 },
            { minSize: 768, group: 2 },
            { minSize: 992, group: 3 },
            { minSize: 1200, group: 6 },
          ].reverse().find((size) => {
            if($(window).width() >= size.minSize) {
              if(relatedContentFlickity.options.groupCells !== size.group) {
                relatedContentFlickity.options.groupCells = size.group;

                relatedContentFlickity.resize();
              }

              return size;
            }
          });
        }));
      });
    }
  }

}

function runFlickityOnRelatedContentProduct() {
  const relatedContentProduct = document.querySelectorAll('.related-content--product .related-content__list');
  if (relatedContentProduct) {
    Array.prototype.slice.call(relatedContentProduct).map((el) => {

      const relatedContentFlickity = new Flickity(el, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        wrapAround: true,
      });


      $(window).on('resize load', window.requestAnimationFrame.bind(window, () => {
        [
          { minSize: 0, group: 1 },
          { minSize: 768, group: 2 },
          { minSize: 992, group: 3 },
          { minSize: 1200, group: 4 },
        ].reverse().find((size) => {
          if ($(window).width() >= size.minSize) {
            if (relatedContentFlickity.options.groupCells !== size.group) {
              relatedContentFlickity.options.groupCells = size.group;

              relatedContentFlickity.resize();
            }

            return size;
          }
        });
      }));
    });
  }
}

function runSwiffysliderOnRelatedContentProduct() {
  global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
  global.swiffyslider.init();          // start swiffyslider
}